export const clientPermission = {
  isClient: true,
};
